import React, { Component, Fragment } from 'react';
import { Button, Col, Row } from 'reactstrap';
import LoggedContext from '../BusinessObjects/LoggedContext';
import { themeBackButton, themeCol3, themeCol9, themeFormInput, themeGroup, themeSaveButton } from '../Utils/EsaedroTheme';

interface IEsaedroJSONComponentProps {
    component: any
    fieldName: string
    canEdit: boolean
    suggestedKeys?: string
    onChange?(event: any) : void
}

interface IEsaedroJSONComponentState {
  component: any
  componentFields: string[]
  newKeyLabel: string
  newKeyValue: string
  addingField: boolean
}

export default class EsaedroJSONComponent extends Component<IEsaedroJSONComponentProps,IEsaedroJSONComponentState> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  
  constructor(props: IEsaedroJSONComponentProps){
    super(props);

    this.state = {
      component: {},
      componentFields: [],
      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    };
  }

  componentDidMount(){
    const {component} = this.props

    // Già costruendo il component popolo le sue chiavi, ma controllo che sia effettivamente un JSON
    let isJson = this.isJSON(component)
    let jsonObject = isJson? JSON.parse(component) : component
    let keys =  isJson? 
                  Object.keys(jsonObject)
                  : []

    // Controllo se ha già tutte le chiavi che dovrebbe avere, altrimenti le aggiungo
    if (this.props.suggestedKeys) {
      // Se non ha chiavi allora aggiungo le chiavi proposte
      if (keys.length == 0) {
        keys = this.props.suggestedKeys.split("|")
      }
    }

    this.setState({
      component: jsonObject,
      componentFields: keys,
      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    })
  }

  // Controlla che l'oggetto sia effettivamente un JSON
  isJSON = (object: any) : boolean => {
    try {
      JSON.parse(object)
    }
    catch (e)
    {
      return false
    }
    return true
  }

  addKey = () => {
    // Aggiunge una chiave all'oggetto
    const {component, componentFields, newKeyLabel, newKeyValue} = this.state
    let newKeys = componentFields
    let newComp = component
    newKeys.push(newKeyLabel)
    newComp[newKeyLabel] = newKeyValue

    this.setState({
      newKeyLabel: "",
      newKeyValue: "",
      addingField: false
    })

    if (this.props.onChange) {
      let customEvent = new CustomEvent("JSONObjectChanged", {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(newComp)}})
      this.props.onChange(customEvent)
    }
  }

  toggleAddField = () => {
    this.setState({addingField: !this.state.addingField})
  }

  handleChange = (event: any) => {
    const target = event.target
    const {component, componentFields} = this.state

    if (target.name == "NewKey") {
      this.setState({newKeyLabel: target.value})
    }
    
    else if (target.name == "NewKeyValue") {
      this.setState({newKeyValue: target.value})
    }

    else {
      let value = target.value
      var key = target.name;

      if (componentFields.length > 0) {
        let tempObj = component;
        tempObj[key] = value;

        if (this.props.onChange) {
          let customEvent = new CustomEvent("JSONObjectChanged", {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(tempObj)}})
          this.props.onChange(customEvent)
        }
      }
      else {
        let tempObj = component;
        tempObj = value;       
        
        if (this.props.onChange) {
          let customEvent = new CustomEvent("JSONObjectChanged", {detail: {"name" : this.props.fieldName, "value" : tempObj}})
          this.props.onChange(customEvent)
        }
      }
    }
  }

  handleRecursiveChange = (event: any) => {

    const {component} = this.state

    // Elabora il campo JSON, lo setta all'oggetto padre e poi manda il padre a chi ha renderizzato il component
    if (event.type == "JSONObjectChanged") {
      let value = event.detail["value"]
      var name = event.detail["name"]
      let tempObj = component;
      tempObj[name] = value;

      if (this.props.onChange) {
        let customEvent = new CustomEvent("JSONObjectChanged", {detail: {"name" : this.props.fieldName, "value" : JSON.stringify(tempObj)}})
        this.props.onChange(customEvent)
      }
    }
  }

  renderJSONField = (fieldKey: string) : any => {

    const {component} = this.state
    return (
      this.isJSON(component[fieldKey]) ?  
            <Row className={themeGroup()}>
              <Col className={themeCol3()}>
                <label htmlFor={fieldKey}>{fieldKey}</label>   
              </Col>
              <Col className={themeCol9()}>
                <EsaedroJSONComponent 
                  component={component[fieldKey]} 
                  fieldName={fieldKey} 
                  canEdit={this.props.canEdit} 
                  onChange={this.handleRecursiveChange}>
                </EsaedroJSONComponent>
              </Col>
            </Row>
  
            : <Row className={themeGroup()}>
                <Col className={themeCol3()}>
                  <label htmlFor={fieldKey}>{fieldKey}</label>   
                </Col>
                <Col className={themeCol9()}>
                  <input 
                    className={themeFormInput()} 
                    type="text" 
                    name={fieldKey} 
                    disabled={!this.props.canEdit} value={component[fieldKey]} onChange={this.handleChange}/>    
                </Col>
              </Row>                        
    )
  }
  
  render() {
    const {component, componentFields} = this.state

    const content = componentFields.length > 0 ? 
                          componentFields.map( (key: string) => {
                          return this.renderJSONField(key)
                          })
                          : <Row className={themeGroup()}>
                              <Col className={themeCol9()}>
                                <input 
                                  className={themeFormInput()} 
                                  type="text" 
                                  name={component} 
                                  disabled={!this.props.canEdit} value={component} onChange={this.handleChange}/>    
                              </Col>
                            </Row>

    const addFieldForm = (componentFields.length > 0 && this.props.canEdit) ?
                                  
                                      <Fragment>
                                        <Row>
                                          <label htmlFor="addFieldLabel">Aggiungi campo:</label>
                                        </Row>
                                        <Row className={themeGroup()}>
                                          <Col className={themeCol3()}>
                                            <label htmlFor="newKeyLabel">Chiave:</label>   
                                          </Col>
                                          <Col className={themeCol9()}>
                                            <input 
                                              className={themeFormInput()} 
                                              type="text" 
                                              name={"NewKey"} 
                                              value={this.state.newKeyLabel} onChange={this.handleChange}/>    
                                          </Col>
                                        </Row>
                                        <Row className={themeGroup()}>
                                          <Col className={themeCol3()}>
                                            <label htmlFor="newKeyValueLabel">Valore:</label>   
                                          </Col>
                                          <Col className={themeCol9()}>
                                            <input 
                                              className={themeFormInput()} 
                                              type="text" 
                                              name={"NewKeyValue"} 
                                              value={this.state.newKeyValue} onChange={this.handleChange}/>    
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <Button 
                                              className={themeSaveButton()} 
                                              onClick={this.addKey}
                                            >
                                              <i className="fa fa-plus"> </i>
                                            </Button>
                                          </Col>    
                                          <Col>
                                            <Button 
                                              className={themeBackButton()} 
                                              onClick={this.toggleAddField}
                                            >
                                              <i className="fa fa-close"> </i>
                                            </Button>
                                          </Col>                                    
                                        </Row>
                                      </Fragment>
                                      : undefined

    const addFieldButton = this.state.addingField ? 
                                  undefined
                                  :  <Row>
                                      <Button 
                                        className={themeSaveButton()} 
                                        onClick={this.toggleAddField}
                                      >
                                        <i className="fa fa-plus"> </i> Aggiungi Campo
                                      </Button>
                                    </Row>


    return (
      this.state.addingField  ? <Fragment>{content}{addFieldForm}</Fragment> 
                              : <Fragment>{content}{addFieldButton}</Fragment>
    )
  }
}